import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  maxWidth: number;
}

export const useStyles = makeStyles<Theme, Props>(() => ({
  container: {
    maxWidth: ({ maxWidth }) => maxWidth,
  },
  wrapper: {
    width: ({ maxWidth }) => maxWidth,
  },
  message: {
    whiteSpace: 'pre-wrap',
  },
  confirmButton: {
    minWidth: 136,

    '& .MuiButtonBase-root': {
      width: '100%',
    },
  },
  buttonsContainer: {
    marginTop: 24,
  },
}));
